// duplicate table header in table row for mobile view
export function table() {
  document.querySelectorAll(".wp-block-table").forEach((table) => {
    var headerValues = [];
    table.querySelectorAll("th").forEach((headerValue) => {
      headerValues.push(headerValue.textContent);
    });

    if (headerValues.length === 0) {
      return;
    }

    table.querySelectorAll("tr").forEach((row) => {
      row.querySelectorAll("td").forEach((rowElement, index) => {
        rowElement.innerHTML = `<span class="mobile-table-header">${headerValues[index]}</span>${rowElement.innerHTML}`;
      });
    });
  });
}
